import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import FeederTab from "./FeederTab";
import FeederSchools from "./FeederSchools";
import T from "../translations/Translations";

import "../../styles/FeederTabs.scss";

const FeederBlock = ({ currentFeeder, feeders, formDispatch, formState, oeStudentInfo, setSelectedSchoolTab }) => {
    const [isFeeder, setIsFeeder] = useState(0);
    const [schools, setSchools] = useState([]);
    const [selectedTab, setSelectedTab] = useState(0);

    /**
     * @description Set and sort selectedTab and schools
     * @name handleClick
     * @param {*} feeder
     * @param {*} index
     */
    const handleClick = (feeder, index) => {
        setSchools(feeders[feeder].sort((a, b) => a.locationDto?.name.localeCompare(b.locationDto?.name)));
        setSelectedTab(index);
    };

    /**
     * Set and sort Feeder tab and schools
     * If for some reason, the parent has entered an address that we can't find and assign a feed to, default the
     * feeder to Castle Rock Area and tab to 0 so that we can at least display schools
     */
    useEffect(() => {
        if (currentFeeder) {
            const index = Object.keys(feeders).findIndex((item) => item === currentFeeder);
            if (index !== -1) {
                setIsFeeder(index);
                setSchools(
                    feeders[currentFeeder].sort((a, b) => a.locationDto?.name.localeCompare(b.locationDto?.name))
                );
                setSelectedTab(index);
            }
        } else if (feeders) {
            setIsFeeder("Castle Rock Area");
            setSchools(
                feeders["Castle Rock Area"].sort((a, b) => a.locationDto?.name.localeCompare(b.locationDto?.name))
            );
            setSelectedTab(0);
        }
    }, [currentFeeder, feeders]);

    return (
        <section className="feeder-container">
            <h5 className="dark-blue-text">{T({ key: "OE_Schools_Title" })}</h5>
            <p className="dark-blue-text">{T({ key: "OE_Schools_Body" })}</p>
            <div className="feeder-tab-container">
                {feeders &&
                    Object.keys(feeders).map((feeder, index) => {
                        const uniqueKey = `feeder-tab-${index}`;
                        const { schoolChoiceDetailDtos } = formState;
                        const countArr = feeders[feeder].reduce((results, school) => {
                            const { key } = school;
                            const match = schoolChoiceDetailDtos.filter(
                                (obj) => parseInt(obj.participatingSchoolId, 10) === parseInt(key, 10)
                            );
                            if (match && match.length > 0) {
                                results.push(true);
                            }

                            return results;
                        }, []);

                        return (
                            <FeederTab
                                count={countArr.length}
                                feeder={feeder}
                                feederRegion={oeStudentInfo?.feederRegion}
                                handleClick={() => {
                                    handleClick(feeder, index);
                                }}
                                isFeeder={isFeeder === index}
                                isSelected={index == selectedTab}
                                key={uniqueKey}
                            />
                        );
                    })}
            </div>
            {schools?.length > 0 && (
                <FeederSchools
                    formDispatch={formDispatch}
                    formState={formState}
                    schools={schools}
                    setSelectedSchoolTab={setSelectedSchoolTab}
                />
            )}
        </section>
    );
};

FeederBlock.propTypes = {
    currentFeeder: PropTypes.string,
    feeders: PropTypes.oneOfType([PropTypes.object]).isRequired,
    formDispatch: PropTypes.func.isRequired,
    formState: PropTypes.oneOfType([PropTypes.object]),
    oeStudentInfo: PropTypes.oneOfType([PropTypes.object]),
    setSelectedSchoolTab: PropTypes.func.isRequired
};

FeederBlock.defaultProps = {
    currentFeeder: null,
    oeStudentInfo: null
};

export default FeederBlock;
